module.exports = __webpack_public_path__ + "static/media/round12.57325e98.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/round12.png
// module id = 1163
// module chunks = 0